/* GLADMAX - MERKLISTE (ulubione produkty).
   PRZENIESIONE 1:1 Z OCTAGONA 18.08.2026 na polecenie Dawida
   ("masz gotowy kod w octagon, przekopiuj go do bullkraft").
   Rozne wzgledem Octagona: klucz localStorage, kolory (zloto zamiast
   czerwieni - w CSS), link zapasowy do kolekcji, dodany selektor
   kafelkow slidera bk-reco.

   Klucz localStorage 'bkWishlist' zostaje bez zmian mimo zmiany nazwy
   marki - jego podmiana skasowalaby listy zapisane w przegladarkach
   klientow.

   STAN DOCELOWY:
   - ikona serca renderowana PRZEZ SERWER w
     snippets/bk-header-wishlist.liquid i wstawiana inline-skryptem do
     <header-actions>. TEN PLIK JEJ NIE TWORZY (inaczej byly dwa serca).
   - szkielet strony Merkliste rysuje inline-skrypt w
     sections/bk-merkliste.liquid. Tutaj tylko PODMIENIAMY go na
     prawdziwe kafelki, JEDNYM ruchem - nigdy nie kasujemy zawartosci
     przed pobraniem danych, bo strona zapadalaby sie na chwile.

   ZASADA: zero aplikacji, zero konta klienta. Lista siedzi w
   localStorage pod kluczem 'bkWishlist' i trzyma SAME UCHWYTY (max 60).
   Dane kafelkow ciagniete na swiezo z /products/<handle>.js.
   ZAPISYWANY JEST PRODUKT, NIE WARIANT.

   DLACZEGO JEDEN PLIK, A NIE EDYCJA SZABLONOW: w sklepie sa trzy rodzaje
   kafelka produktu i kazdy ma inny markup:
     1) <product-card>      - kolekcje, wyszukiwarka, polecane
     2) a.bk-prod-item      - sekcje bk-collection (Bestseller na glownej)
     3) a.bk-reco-item      - slider PASST DAZU na karcie produktu
   Stan serduszka i tak MUSI ustawiac JS, bo serwer nie zna localStorage.

   !!! KLIK MUSI BYC PRZECHWYCONY W FAZIE CAPTURE NA DOCUMENT:
   kafelek bk-prod-item to CALY <a>, a w product-card link lezy jako
   osobna warstwa nad trescia. Zwykly listener odpalilby sie za pozno
   i przegladarka przeszlaby na strone produktu.

   Wylacznik: BK_WISH_ON = false. */
(function () {
  'use strict';

  var BK_WISH_ON = true;
  var KEY = 'bkWishlist';
  var MAX = 60;

  if (!BK_WISH_ON) return;

  function R() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  var TXT = {
    empty: 'Deine Merkliste ist noch leer. Tippe auf das Herz bei einem Produkt, um es hier zu speichern.',
    browse: 'Produkte ansehen',
    add: 'Zur Merkliste hinzuf\u00fcgen',
    remove: 'Von der Merkliste entfernen',
    on: 'Gemerkt',
    off: 'Merken',
    soldOut: 'Ausverkauft'
  };

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  /* !!! Ten tekst MUSI byc identyczny z tym w sections/bk-merkliste.liquid,
     inaczej komunikat mrugnie przy wczytaniu strony. */
  function emptyHtml() {
    return '<p class="bk-wl__empty">' + TXT.empty + '</p>' +
      '<p><a class="bk-wl__btn" href="' + R() + 'collections/bestseller">' + TXT.browse + '</a></p>';
  }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Object.prototype.toString.call(arr) === '[object Array]' ? arr : [];
    } catch (e) { return []; }
  }

  function save(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function toggle(handle) {
    var list = read();
    var at = list.indexOf(handle);
    if (at > -1) { list.splice(at, 1); } else { list.unshift(handle); }
    save(list);
    return at === -1;
  }

  function handleFromHref(href) {
    if (!href) return null;
    var m = String(href).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function makeButton(handle, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bk-wish ' + extraClass;
    b.setAttribute('data-bk-wish', handle);
    b.innerHTML = HEART;
    return b;
  }

  /* ---- ikona w naglowku ----
     Tworzy ja SERWER. Tutaj tylko ja odnajdujemy i pilnujemy, zeby po
     przerysowaniu naglowka wrocila do <header-actions>.
     !!! CEL TO <header-actions>, NIGDY .header__row--top: koszyk to
     <cart-drawer-component> z <button> (nie link), a .header__row--top
     to GRID - dodatkowe dziecko spada do nowego wiersza pod paskiem. */

  var navEl = null;

  function placeNav() {
    if (!navEl) { navEl = document.querySelector('[data-bk-wish-nav]'); }
    if (!navEl) return true;
    var actions = document.querySelector('header-actions');
    if (!actions) return true;
    if (navEl.parentNode !== actions) {
      actions.insertBefore(navEl, actions.firstElementChild);
      navEl.hidden = false;
    }
    return true;
  }

  /* ---- doklejanie serduszek do kafelkow ---- */

  function decorate() {
    var i;

    var natives = document.querySelectorAll('product-card:not([data-bk-wish-done])');
    for (i = 0; i < natives.length; i++) {
      (function (card) {
        card.setAttribute('data-bk-wish-done', '1');
        var link = card.querySelector('a[href*="/products/"]');
        var h = link ? handleFromHref(link.getAttribute('href')) : null;
        if (!h) return;
        card.appendChild(makeButton(h, 'bk-wish--card'));
      })(natives[i]);
    }

    var bks = document.querySelectorAll('a.bk-prod-item:not([data-bk-wish-done])');
    for (i = 0; i < bks.length; i++) {
      (function (card) {
        card.setAttribute('data-bk-wish-done', '1');
        var h = handleFromHref(card.getAttribute('href'));
        var wrap = card.querySelector('.bk-prod-item-img-wrap');
        if (!h || !wrap) return;
        wrap.appendChild(makeButton(h, 'bk-wish--card'));
      })(bks[i]);
    }

    var recos = document.querySelectorAll('a.bk-reco-item:not([data-bk-wish-done])');
    for (i = 0; i < recos.length; i++) {
      (function (card) {
        card.setAttribute('data-bk-wish-done', '1');
        var h = handleFromHref(card.getAttribute('href'));
        if (!h) return;
        var wrap = card.querySelector('.bk-reco-item-img-wrap') || card;
        wrap.appendChild(makeButton(h, 'bk-wish--card'));
      })(recos[i]);
    }
  }

  /* ---- odswiezanie stanu wszystkich serduszek i licznikow ---- */

  function sync() {
    var list = read();
    var i;

    var btns = document.querySelectorAll('[data-bk-wish]');
    for (i = 0; i < btns.length; i++) {
      var b = btns[i];
      var on = list.indexOf(b.getAttribute('data-bk-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? TXT.remove : TXT.add);
      var label = b.querySelector('[data-bk-wish-label]');
      if (label) { label.textContent = on ? TXT.on : TXT.off; }
    }

    var navs = document.querySelectorAll('[data-bk-wish-nav]');
    for (i = 0; i < navs.length; i++) {
      navs[i].classList.toggle('is-on', list.length > 0);
    }

    var counters = document.querySelectorAll('[data-bk-wish-count]');
    for (i = 0; i < counters.length; i++) {
      counters[i].textContent = list.length ? String(list.length) : '';
    }
  }

  /* ---- strona Merkliste ---- */

  function money(cents) { return 'CHF ' + (cents / 100).toFixed(2); }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function pageCard(p) {
    var a = document.createElement('a');
    a.className = 'bk-wl__card';
    a.href = R() + 'products/' + p.handle;
    var media = '<div class="bk-wl__media">';
    if (p.featured_image) {
      media += '<img src="' + sized(p.featured_image, 500) + '" alt="" loading="lazy" decoding="async">';
    }
    if (p.available === false) {
      media += '<span class="bk-wl__out">' + TXT.soldOut + '</span>';
    }
    media += '</div>';
    a.innerHTML = media + '<p class="bk-wl__name"></p><p class="bk-wl__price">' + money(p.price) + '</p>';
    a.querySelector('.bk-wl__name').textContent = p.title;
    a.appendChild(makeButton(p.handle, 'bk-wish--card'));
    return a;
  }

  function renderPage() {
    var host = document.getElementById('bk-wishlist');
    if (!host) return;
    var list = read();

    if (!list.length) { host.innerHTML = emptyHtml(); return; }

    Promise.all(list.map(function (h) {
      return fetch(R() + 'products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var grid = document.createElement('div');
      grid.className = 'bk-wl__grid';
      var alive = [];

      results.forEach(function (p) {
        if (!p || !p.handle) return;
        alive.push(p.handle);
        grid.appendChild(pageCard(p));
      });

      if (alive.length !== list.length) { save(alive); }

      if (!alive.length) { host.innerHTML = emptyHtml(); sync(); return; }

      /* !!! PODMIANA JEDNYM RUCHEM - szkielet z sekcji stoi do konca,
         wiec strona nie zapada sie do zerowej wysokosci. */
      host.innerHTML = '';
      host.appendChild(grid);
      sync();
    });
  }

  /* ---- zdarzenia ---- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-bk-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-bk-wish');
    var added = toggle(handle);
    btn.classList.add('bk-wish--pulse');
    if (!navEl) { navEl = document.querySelector('[data-bk-wish-nav]'); }
    if (navEl) {
      navEl.classList.add('bk-wishnav--pulse');
      setTimeout(function () { navEl.classList.remove('bk-wishnav--pulse'); }, 420);
    }
    setTimeout(function () { btn.classList.remove('bk-wish--pulse'); }, 320);
    sync();
    if (!added && document.getElementById('bk-wishlist')) {
      var card = btn.closest('.bk-wl__card');
      if (card) {
        card.parentNode.removeChild(card);
        if (!document.querySelectorAll('.bk-wl__card').length) { renderPage(); }
      } else {
        renderPage();
      }
    }
  }, true);

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    sync();
    if (document.getElementById('bk-wishlist')) { renderPage(); }
  });

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () { placeNav(); decorate(); sync(); }, 120);
  }

  function boot() {
    placeNav();
    decorate();
    sync();
    renderPage();
    if (window.MutationObserver) {
      new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) { sync(); } });
})();
